import { render, staticRenderFns } from "./CounterWithImageBlock.vue?vue&type=template&id=472a2cd2"
import script from "./CounterWithImageBlock.vue?vue&type=script&lang=js"
export * from "./CounterWithImageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports